import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { styled, css } from 'styled-components';
const TooltipContent = styled.div `
  position: relative;
  padding: 7px 12px;
  max-width: 300px;
  &:before {
    content: '';
    display: block;
    position: absolute;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
  }
`;
const TooltipComponent = styled.div `
  display: inline-flex;
  position: fixed;
  background: #000;
  color: #fff;
  font-size: 13px;
  width: auto !important;
  height: auto;
  border-radius: 3px;
  z-index: 9999;
  min-height: 0 !important;
  ${({ $fixedPosition }) => $fixedPosition === 'top' &&
    css `
      transform: translateX(-50%) translateY(-100%) translateY(-8px);
    `};
  ${TooltipContent} {
    ${({ $fixedPosition }) => $fixedPosition === 'top' &&
    css `
        &:before {
          top: 100%;
          left: 50%;
          margin-left: -5px;
          border-width: 5px 5px 0;
          border-top-color: #000;
        }
      `};
  }
`;
const context = React.createContext(() => { });
const Tooltip = React.memo(function Tooltip({ point }) {
    if (!point) {
        return null;
    }
    return (_jsx(TooltipComponent, { style: { top: point.y, left: point.x }, "$fixedPosition": point.fixedPosition, children: _jsx(TooltipContent, { children: point.message }) }));
});
const TooltipProvider = ({ children }) => {
    const [point, setPoint] = React.useState(undefined);
    return (_jsxs(context.Provider, { value: setPoint, children: [_jsx(Tooltip, { point: point }), children] }));
};
const useTooltip = () => {
    const setPoint = React.useContext(context);
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-restricted-syntax
    const show = React.useCallback((x, y, message, fixedPosition) => {
        setPoint({
            x,
            y,
            message,
            fixedPosition,
        });
    }, [setPoint]);
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-restricted-syntax
    const hide = React.useCallback(() => setPoint(undefined), [setPoint]);
    return React.useMemo(() => [show, hide], [show, hide]);
};
export { TooltipContent, TooltipComponent, TooltipProvider, Tooltip, useTooltip };
